import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../../InputField';
import SelectField from '../../SelectField';
import FormError from '../../FormError';
import { prettyKey } from 'helpers/formatters';
import { required, maxLength255, maxLength20 } from 'helpers/validators';

const productsOptions = [
  [1518, '1518 | Device Rental Fee $10'],
  [1536, '1536 | Device Rental Fee $15'],
];

let LeaseForm = (props) => {
  const { handleSubmit, error, loading } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="product"
          label="Product"
          options={productsOptions}
          empty="Select product"
          validate={[required]}
        />
        <Field
          component={InputField}
          name="description"
          label={prettyKey('description')}
          validate={[maxLength255]}
        />
        <Field
          component={InputField}
          name="imei"
          label={prettyKey('imei')}
          validate={[required, maxLength20]}
        />
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-primary" disabled={loading}>
          Save Lease
        </button>
      </form>
    </div>
  );
};

LeaseForm = reduxForm({
  form: 'lease',
})(LeaseForm);

export default LeaseForm;
